import { FlexBox } from '@fable/components'
import { css, useTheme } from '@fable/theme'
import { useHome } from 'app/marketing/context'
import { PageContainerV2 } from 'components/v2'
import { AppDownloadAnchorLink } from 'app/marketing/components/AppDownloadAnchorLink'

export const SearchFilterResults = ({
  results,
  showAppDownloadCta,
}: {
  results: React.ReactElement[]
  showAppDownloadCta: boolean
}) => {
  const { activeFilter } = useHome()
  const { mediaQueries, colors } = useTheme()

  return (
    <PageContainerV2
      data-testid={`clubs-filter-results-${activeFilter}`}
      className={css`
        padding-bottom: 52px;
        position: relative;
      `}
    >
      <div
        className={css`
          margin: 0 auto;
          display: grid;
          grid-template-columns: repeat(1, 1fr);
          gap: 24px;
          ${mediaQueries.mobile} {
            grid-template-columns: repeat(2, 1fr);
            max-width: 520px;
          }
          ${mediaQueries.tablet} {
            grid-template-columns: repeat(3, 1fr);
            max-width: 800px;
          }
          ${mediaQueries.desktop} {
            grid-template-columns: repeat(4, 1fr);
            gap: 42px 62px;
            max-width: none;
          }
        `}
      >
        {results}
      </div>
      {showAppDownloadCta ? (
        <FlexBox
          className={css`
            padding: 0 16px;
            width: 100%;
            height: 118vw;
            background: linear-gradient(
              rgba(252, 249, 245, 0),
              ${colors.uiPearlUltraLight} 80%
            );
            position: absolute;
            bottom: 52px;
            left: 0;
            ${mediaQueries.mobileXS} {
              height: 100vw;
            }
            ${mediaQueries.mobile} {
              height: 372px;
            }
          `}
          centerAll
        >
          <AppDownloadAnchorLink
            title="Discover more clubs on the app"
            className={css`
              max-width: 280px;
              transform: translateY(-12vw);
              ${mediaQueries.mobile} {
                transform: translateY(-68px);
              }
            `}
            anchor={{ id: 'app-download', offset: 160 }}
          />
        </FlexBox>
      ) : null}
    </PageContainerV2>
  )
}
